import { X } from 'react-feather';
// @ts-ignore
import { animated } from 'react-spring';
import styled, { css } from 'styled-components';
import { color, space, width } from 'styled-system';
import { SCREEN } from '../../../theme/breakpoints';

const isWeb = SCREEN.isWeb;

export const ModalWrap = styled(animated.div)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: calc(100vw / var(--ib-ui-scale, 1));
  z-index: 1000;
  height: calc(100vh / var(--ib-ui-scale, 1));
  overflow: auto;
  display: flex;
  padding: ${isWeb ? '20px' : '5px'};
  position: fixed;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
`;

type CustomModalInnerProps = {
  bg?: string;
};

type ModalBodyContProps = {
  hasAction?: boolean;
};

type ModalHeaderContProps = {
  hasBody?: boolean;
};

export const ModalInner = styled(animated.div)<any>`
  display: flex;
  max-height: 100%;
  max-width: 100%;
  border-radius: 5px;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  background-color: #fff;
  justify-content: center;
  overflow: auto;
  width: ${props =>
    props.hasChildren ? 'auto' : isWeb ? 'calc(48vw / var(--ib-ui-scale, 1))' : 'calc(100vw / var(--ib-ui-scale, 1))'};
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  ${space};
  ${color};
  ${width};
`;

export const CustomModalInner = styled(animated.div)<CustomModalInnerProps>`
  width: auto;
  display: flex;
  max-width: 100%;
  border-radius: 5px;
  align-items: center;
  box-sizing: border-box;
  overflow: auto;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
  background-color: ${props => props.bg || 'white'};
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
`;

export const ModalHeaderCont = styled.div<ModalHeaderContProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-start;
  border-bottom: 1px solid #222;

  ${({ hasBody }) =>
    hasBody &&
    css`
      margin-bottom: 0;
    `}
`;

export const ModalBodyCont = styled.div<ModalBodyContProps>`
  width: 100%;
  height: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-x: hidden;
  overflow-y: auto;
  border-bottom: ${props => (props.hasAction ? 'none' : '1px solid #f1f7fb')};
`;

export const ModalFooterCont = styled.div`
  width: 100%;
  display: flex;
  padding-top: 20px;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const CloseButton = styled(X)<any>`
  right: 20px;
  width: 20px;
  height: 20px;
  z-index: 1001;
  font-size: 40px;
  position: absolute;
  color: rgba(0, 0, 0, 0.6);
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &:hover {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.9);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;
